import React from 'react';
import { Link } from 'react-router-dom';
import { getLocaleObjContent } from '@/utils/language.util';

export default function SharePage() {
    return (
        <div id="wrap" className="main sub_page">
            <div className="history">
                <Link to="/home" className="tit">
                    <h2 className="inner">Share</h2>
                </Link>
                <div className="sp15"></div>
                <div className="inner">
                    <ul className="nav_share">
                        {getLocaleObjContent('lstShare').map((it, index) => (
                            <li key={index}>
                                <Link to="#">
                                    <img src={require(`../../resources/assets/images/${it.img}`)} alt={it.alt} />
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
}
